import React from 'react';
import ContentfulImage from "../../../Contentful/ContentfulImage";

export const Thumbnail = ({src}) => {
    return <ContentfulImage src={src} width={600} />
}
